<template>
  <v-container class="d-flex justify-center align-center" style="min-height:90vh;">
    <v-card class="rounded-3xl shadow-xl px-8 py-8" max-width="430">
      <!-- AVATAR con overlay para cambiar foto -->
        <div class="relative text-center mb-6">
            <!--input ref="fileInput" type="file" accept="image/*" class="hidden" @change="onAvatarChange" v-show="false"/>
            <v-avatar size="100" class="mx-auto mb-2 avatar-uploader" :color="user.profile_photo_path ? '' : 'primary'" @click="triggerFile" style="cursor:pointer; transition: box-shadow 0.3s;">
                <template v-if="avatarPreview">
                    <v-img :src="avatarPreview" />
                </template>
                <template v-else>
                    <v-icon size="80">mdi-account-circle</v-icon>
                </template>
                <div class="avatar-overlay" v-if="!avatarLoading">
                    <v-icon size="28">mdi-camera</v-icon>
                    <span style="font-size:0.8rem;">Cambiar foto</span>
                </div>
                <div v-if="avatarLoading" class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-full">
                    <v-progress-circular indeterminate color="primary" size="44"/>
                </div>
            </v-avatar>
            <div v-if="avatarPreview && editMode" class="mt-1">
                <v-btn size="x-small" variant="text" color="error" @click="removeAvatar">
                    <v-icon>mdi-delete</v-icon> Quitar foto
                </v-btn>
            </div-->
            <v-avatar size="100" class="mx-auto mb-2 avatar-uploader" color="primary" style="font-size:50px;">
                {{user?.name?.slice(0,1)}}
            </v-avatar>
        </div>
        
      <!-- Nombre, email, rol y editar -->
      <v-row class="flex items-center justify-center gap-2 mb-2">
        <v-card-title>{{ form.name }}</v-card-title>
        <!--v-btn v-if="!editMode" size="x-small" icon variant="text" @click="editMode = true" aria-label="Editar datos">
          <v-icon size="20">mdi-pencil</v-icon>
        </v-btn-->
      </v-row>
      <v-row class="ma-0 justify-center">
        <v-card-subtitle>{{ form.email }}</v-card-subtitle>
      </v-row>
      <v-row class="ma-0 justify-center mt-4">
        <v-chip size="x-small" class="mb-1">
            {{ user.role }}
        </v-chip>
      </v-row>

      <!-- Datos en modo edición -->
      <!--v-form v-if="editMode" @submit.prevent="saveProfile" class="fadein mb-2" ref="profileForm">
        <v-text-field
          label="Nombre"
          v-model="form.name"
          prepend-inner-icon="mdi-account"
          density="comfortable"
          required
        />
        <v-text-field
          label="Correo"
          v-model="form.email"
          prepend-inner-icon="mdi-email"
          density="comfortable"
          required
        />
      </v-form>

      <v-divider class="my-4" /-->

      <!-- Contraseña -->
      <v-row v-if="!editPassword" class="flex justify-center gap-2 mb-2">
        <!--card-subtitle style="cursor:pointer;" @click="editPassword = true">Modificar Contraseña</card-subtitle-->
      </v-row>
      <v-form v-else @submit.prevent="savePassword" class="fadein my-2" ref="passwordForm">
        <v-text-field
          v-model="password.new"
          label="Nueva contraseña"
          :type="showPassword ? 'text' : 'password'"
          prepend-inner-icon="mdi-lock"
          density="comfortable"
          :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append-inner="showPassword = !showPassword"
          required
          variant="solo-filled"
        />
        <v-text-field
          v-model="password.confirm"
          label="Confirmar contraseña"
          :type="showPassword ? 'text' : 'password'"
          prepend-inner-icon="mdi-lock-check"
          density="comfortable"
          required
          variant="solo-filled"
        />
        <div class="d-flex gap-2 mt-2">
          <v-btn color="primary" type="submit" variant="text">Guardar</v-btn>
          <v-btn variant="text" @click="editPassword = false">Cancelar</v-btn>
        </div>
      </v-form>

      <v-divider class="my-4" />

      <!-- Botones de acción -->
      <div v-if="editMode" class="d-flex gap-2 mb-4">
        <v-btn color="primary" @click="saveProfile" variant="text">Guardar cambios</v-btn>
        <v-btn @click="cancelEdit" variant="text">Cancelar</v-btn>
      </div>
      <v-btn block color="error" variant="tonal" class="mt-4" @click="logout">
        <v-icon class="mr-2">mdi-logout</v-icon>
        Cerrar sesión
      </v-btn>
    </v-card>
  </v-container>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';
import { useAuthStore } from '@/store/auth';
import { useUsersStore } from '@/store/users';
import { useFileUploadStore } from '@/store/fileUpload';
import { useAlertStore } from '@/store/alertStore';
import { useRouter } from 'vue-router';

const authStore = useAuthStore();
const usersStore = useUsersStore();
const fileUploadStore = useFileUploadStore();
const alertStore = useAlertStore();
const router = useRouter();

const user = computed(() => authStore.user || {});
const editMode = ref(false);
const editPassword = ref(false);
const showPassword = ref(false);

const form = ref({
  name: user.value.name || '',
  email: user.value.email || '',
  profile_photo_path: user.value.profile_photo_path || '',
});
const password = ref({ new: '', confirm: '' });

const avatarPreview = ref(form.value.profile_photo_path);
const avatarLoading = ref(false);

const fileInput = ref<HTMLInputElement | null>(null);

function triggerFile() {
  (fileInput.value as HTMLInputElement).click();
}

async function onAvatarChange(e: Event) {
  const file = (e.target as HTMLInputElement).files?.[0];
  if (!file) return;
  avatarLoading.value = true;

  // Preview inmediato (opcional)
  const reader = new FileReader();
  reader.onload = (event) => {
    avatarPreview.value = event.target?.result as string;
  };
  reader.readAsDataURL(file);

  try {
    // 1. Sube el archivo con tu store de archivos
    const url = await fileUploadStore.uploadFile('users', file);
    // 2. Actualiza el usuario con la nueva foto
    await usersStore.updateUser(user.value.id, { profile_photo_path: url });
    // 3. Actualiza en authStore (por si lo usas en la barra)
    authStore.user.profile_photo_path = url;
    form.value.profile_photo_path = url;
    avatarPreview.value = url;
    alertStore.showAlert('Foto de perfil actualizada', 'success');
  } catch (error) {
    alertStore.showAlert('Ocurrió un error al subir la foto', 'error');
    avatarPreview.value = user.value.profile_photo_path;
  } finally {
    avatarLoading.value = false;
  }
}

function removeAvatar() {
  avatarPreview.value = '';
  form.value.profile_photo_path = '';
  usersStore.updateUser(user.value.id, { profile_photo_path: '' });
  authStore.user.profile_photo_path = '';
  alertStore.showAlert('Foto eliminada', 'success');
}

function saveProfile() {
  usersStore.updateUser(user.value.id, { ...form.value });
  editMode.value = false;
  alertStore.showAlert('Perfil actualizado', 'success');
}
function savePassword() {
  if (password.value.new !== password.value.confirm) {
    alertStore.showAlert('Las contraseñas no coinciden', 'error');
    return;
  }
  usersStore.updatePassword(user.value.id, password.value.new);
  editPassword.value = false;
  password.value.new = '';
  password.value.confirm = '';
}
function cancelEdit() {
  form.value.name = user.value.name;
  form.value.email = user.value.email;
  avatarPreview.value = user.value.profile_photo_path;
  editMode.value = false;
}
function logout() {
  authStore.logout();
  router.push({ name: 'Login' });
}
</script>

<style>
.avatar-uploader {
  position: relative;
  overflow: visible;
}
.avatar-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.37);
  display: flex;
  flex-direction: column;
  opacity: 0;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: white;
  font-size: 0.95rem;
  font-weight: 500;
  pointer-events: none;
  transition: opacity 0.22s;
  z-index: 2;
}
.avatar-uploader:hover .avatar-overlay,
.avatar-uploader:focus-within .avatar-overlay {
  opacity: 1;
  pointer-events: auto;
}

</style>